import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, strokeWidth, typography } = themeVariables;

export const reviewer = css`
  display: flex;
  align-items: baseline;
  gap: var(${spacing.xs});
  margin: 0;
  padding-top: var(${spacing.sm});
  border-top: var(${strokeWidth}) solid var(${colors.stroke.default});
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
`;

/**
 * Holds text to a single line, ellipsising rather than wrapping.
 *
 * Both halves of this footer need it: a customer-supplied name or location long enough to
 * wrap would take the footer onto a second line and the card's height with it, and in a
 * row of cards that are filling their row, every card's. `min-width: 0` is what makes
 * it work in a flex row, where an item's automatic minimum size is its content and it
 * otherwise refuses to shrink far enough to ellipsise.
 *
 * Exported because `ReviewCardReply` needs the same rule for the same reason.
 */
export const oneLine = css`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

/* 700 is a literal because the theme has one body weight and no bold step. */
export const name = css`
  ${oneLine}
  font-weight: 700;
  color: var(${colors.content.secondary});
`;

export const location = css`
  ${oneLine}
  color: var(${colors.content.tertiary});
`;
